import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IAnswerEnglishIqV1Request } from './answer-english-iq-v1-request';
import type { IAnswerEnglishIqV1Response } from './answer-english-iq-v1-response';
import { answerEnglishIqV1ResponseSchema } from './answer-english-iq-v1-response';

export async function answerEnglishIqV1Api(
  body: IAnswerEnglishIqV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IAnswerEnglishIqV1Response>> {
  return postRequest<IAnswerEnglishIqV1Response>({
    body,
    options,
    path: '/english-iq/answer/v1',
    schema: answerEnglishIqV1ResponseSchema,
  });
}
